// extracted by mini-css-extract-plugin
export default {"portrait":"styles---portrait---L6hlp","avatars":"styles---avatars---VTIE8","companyAvatar":"styles---companyAvatar---HViOw"};